import React from "react";
import {
  Breadcrumb,
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  Fabric,
  FocusTrapZone,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  ITag,
  PrimaryButton,
  SelectionMode,
  Stack,
  Text,
  TooltipHost,
} from "@fluentui/react";
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiDotsVertical,
  mdiTrashCanOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment";
import { Link, useHistory, useParams } from "react-router-dom";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { IPreventiveMaintenenceSchedule } from "../../../vm";
import {
  deletePMScheduleFile,
  getAllPMScheduleFile,
} from "../../../services/pm-schedule/PMScheduleService";
import { parseJwt } from "../../../services/UtilService";
import { getAllDataCentersOfCustomer } from "../../../services/datacenter/DatacenterService";
import { THEME } from "../../../utils/Styles";
import { Loading } from "../../../services/Loading";
import {
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from "../../common/Constants";
import NoDataTile from "../../common/NoDataTile";
import ManagePMScheduleDialog from "../../pm-schedule/ManagePMScheduleDialog";
import { getAllCustomers } from "../../../services/customers/CustomerService";
import TotalNumbers from "../../common/TotalNumbers";

export interface PMScheduleProps { }

let calendarButtonElement: HTMLElement;

let datacenterDict: { [Key: string]: string } = {};

const PMSchedule: React.FC<PMScheduleProps> = () => {
  // custom hooks
  const params: any = useParams();
  const history = useHistory();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    pmsFiles: [],
    managePmsDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    isLoading: false,
    search: {
      date: new Date(),
      customerId: params.customerId,
      isFromDatacenter: false,
    },
    showCallender: false,
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      index: undefined,
      data: undefined,
    },
    dataCenterList: [],
  } as {
    pmsFiles: IPreventiveMaintenenceSchedule[];
    managePmsDialog: {
      isOpen: boolean;
      index?: number;
      data?: IPreventiveMaintenenceSchedule;
    };
    isLoading: boolean;
    search: {
      date: Date | string;
      customerId: string;
      isFromDatacenter: boolean;
    };
    showCallender: boolean;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IPreventiveMaintenenceSchedule;
    };
    dataCenterList: ITag[];
  });

  const [customer, setCustomer] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
  } as {
    isLoading: boolean;
    customer: any;
  });

  // hooks
  React.useEffect(() => {
    const asynFunc = async () => {
      await getAllPmsFiles();
      await getACustomer();
    };
    asynFunc();
  }, []);

  const getACustomer = async () => {
    setCustomer({ ...customer, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result?.success) {
      setCustomer({
        ...customer,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setCustomer({ ...customer, isLoading: false });
    }
  };

  const getAllPmsFiles = async () => {
    setState({ ...state, isLoading: true });
    let tempSearch = { ...state.search };
    tempSearch.date = moment(tempSearch.date).format("YYYY-MM-DD");
    let result = await getAllPMScheduleFile(tempSearch);
    if (result && result.success) {
      //   setState({
      //     ...state,
      //     pmsFiles: result.data,
      //     isLoading: false,
      //   });
      getDataCenters(result.data);
    } else {
      showToast(result?.message || "Error while getting files", "error");
      setState({ ...state, isLoading: false });
    }
  };

  const getDataCenters = async (data: IPreventiveMaintenenceSchedule[]) => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCentersOfCustomer(params.customerId);
    if (result?.success) {
      let dataCenterList: ITag[] = [];

      result.data.forEach((item) => {
        dataCenterList.push({
          key: item._id as string,
          name: item.name,
        });
        datacenterDict[item._id as string] = item.name;
      });

      console.log("ddict", datacenterDict);

      setState({
        ...state,
        pmsFiles: data,
        dataCenterList,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting datacenter", "error");
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let pmsFiles = undefined;
    if (index !== undefined) {
      pmsFiles = { ...state.pmsFiles[index] };
    }
    setState({
      ...state,
      managePmsDialog: {
        isOpen,
        index,
        data: pmsFiles,
      },
    });
  };

  const handleDialogClose = (data: IPreventiveMaintenenceSchedule) => {
    let pmsFiles = [...state.pmsFiles];
    if (data) {
      if (state.managePmsDialog.index !== undefined) {
        pmsFiles[state.managePmsDialog.index] = data;
        showToast("PMS file uploaded successfully", "success");
      } else {
        if (
          moment(data.date).format("YYYY") ===
          moment(state.search.date).format("YYYY")
        ) {
          pmsFiles.unshift(data);
          showToast("PMS file uploaded successfully", "success");
        } else {
          showToast("PMS file uploaded successfully", "success");
        }
      }
    }
    setState({
      ...state,
      managePmsDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      pmsFiles,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deletePmsFile = async (
    item: IPreventiveMaintenenceSchedule,
    index: number
  ) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete this file",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deletePMScheduleFile({
          customerId: params.customerId,
          documentId: item._id as string,
        });
        if (result.success) {
          showToast("PMS file deleted successfully", "success");
          let pmsFiles = [...state.pmsFiles];
          pmsFiles.splice(index, 1);
          setState({
            ...state,
            pmsFiles,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(result.message || "Error while deleting file", "error");
        }
      }
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color="#135c8a"
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={`Delete File`}
          //     id={`deletefile`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deletePmsFile(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "fileUrl":
        return (
          <a
            href={item.fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            download="aaa.xlsx"
          >
            {String(item.file).split("[separator]").length > 1
              ? String(item.file).split("[separator]")[
              String(item.file).split("[separator]").length - 1
              ]
              : "Download"}
          </a>
        );
      case "date":
        return (
          <Text style={{ fontWeight: 600 }}>
            {moment(item.date).format("YYYY")}
          </Text>
        );
      case "lastFileUpdatedTime":
        return (
          <Text>
            {moment(item.lastFileUpdatedTime).format("DD/MM/YYYY hh:mm:ss A")}
          </Text>
        );
      case "datacenterId":
        return <Text>{datacenterDict[item.datacenterId]}</Text>;
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  //   const onNextOrPrevFunc = async (isNext: boolean) => {
  //     let searchObj = { ...state.search };
  //     if (isNext) {
  //       searchObj.offset = searchObj.offset + searchObj.limit;
  //     } else {
  //       searchObj.offset = searchObj.offset - searchObj.limit;
  //     }
  //     await getAllPmsFiles(searchObj);
  //   };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const onSearch = async () => {
    await getAllPmsFiles();
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IPreventiveMaintenenceSchedule
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {(state.isLoading || customer.isLoading) && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: customer.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${customer.customer._id}`);
                },
              },
              {
                text: "Preventive Maintenence Schedule",
                key: "preventive-maintenence-schedule",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal wrap tokens={childrenGap}>
            <Stack.Item>
              <div
                ref={(calendarBtn) => (calendarButtonElement = calendarBtn!)}
              >
                <DefaultButton
                  text={
                    !state.search.date
                      ? "Select a Year"
                      : moment(state.search.date).format("YYYY")
                  }
                  onClick={() => setState({ ...state, showCallender: true })}
                  className="month-picker-btn"
                />
              </div>
              {state.showCallender && (
                <Callout
                  isBeakVisible={false}
                  gapSpace={0}
                  doNotLayer={false}
                  target={calendarButtonElement}
                  directionalHint={DirectionalHint.bottomLeftEdge}
                  onDismiss={() => closeCallender()}
                  setInitialFocus
                >
                  <FocusTrapZone
                    firstFocusableSelector="ms-DatePicker-day--today"
                    isClickableOutsideFocusTrap
                  >
                    <Calendar
                      // eslint-disable-next-line react/jsx-no-bind
                      onSelectDate={(date: Date | null | undefined) => {
                        setState({
                          ...state,
                          search: {
                            ...state.search,
                            date: date as Date,
                          },
                          showCallender: false,
                        });
                      }}
                      onDismiss={() => closeCallender()}
                      isMonthPickerVisible={true}
                      value={new Date(state.search.date)}
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DayPickerStrings}
                      isDayPickerVisible={false}
                      highlightCurrentMonth={false}
                      highlightSelectedMonth={true}
                      showMonthPickerAsOverlay={false}
                      showGoToToday={false}
                    />
                  </FocusTrapZone>
                </Callout>
              )}
            </Stack.Item>
            <Stack.Item>
              <PrimaryButton text="Search" onClick={onSearch} />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <Stack.Item>
              <TotalNumbers value={state.pmsFiles.length} />
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item align="end">
                <PrimaryButton
                  text="Add PMS File"
                  onClick={() => handleDialogOpen(true)}
                  className="borderless-btn bg-white"
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.pmsFiles && state.pmsFiles.length > 0 ? (
            <Fabric>
              <DetailsList
                items={state.pmsFiles}
                columns={
                  ![2, 4, 5].includes(tokenData.role)
                    ? [
                      {
                        key: "date",
                        name: "Year",
                        fieldName: "date",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "datacenterId",
                        name: "Datacenter",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "fileUrl",
                        name: "File",
                        fieldName: "fileUrl",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "lastFileUpdatedTime",
                        name: "Last Updated At",
                        fieldName: "lastFileUpdatedTime",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                    ]
                    : [
                      {
                        key: "date",
                        name: "Year",
                        fieldName: "date",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "datacenterId",
                        name: "Datacenter",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "fileUrl",
                        name: "File",
                        fieldName: "fileUrl",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "lastFileUpdatedTime",
                        name: "Last Updated At",
                        fieldName: "lastFileUpdatedTime",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                    ]
                }
                onRenderItemColumn={_renderItemColumn as any}
                compact={true}
                setKey="set"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No PMS File Found For this Year"></NoDataTile>
          )}
        </Stack.Item>
        {/* <Stack.Item className="mr-6" align="end">
          <span
            onClick={
              state.search.offset === 0
                ? undefined
                : () => onNextOrPrevFunc(false)
            }
            className={
              state.search.offset === 0 ? "btn-disabled" : "btn-enabled pointer"
            }
          >
            <Icon
              path={mdiChevronLeft}
              size={0.9}
              className="btnIcon"
              style={{
                marginBottom: -6,
                marginRight: -8,
                color: "#135c8a",
              }}
            />
            <DefaultButton
              text="Previous"
              className="borderless-btn"
              // disabled={state.search.offset === 0}
              // onClick={() => {
              //   onNextOrPrevFunc(false);
              // }}
            />
          </span>
          <span className="nxt-prv-btn-border"></span>
          <span
            onClick={
              state.pmsFiles.length < state.search.limit
                ? undefined
                : () => onNextOrPrevFunc(true)
            }
            className={
              state.pmsFiles.length < state.search.limit
                ? "btn-disabled"
                : "btn-enabled pointer"
            }
          >
            <DefaultButton
              text="Next"
              className="borderless-btn"
              // disabled={state.escalationMatrixs.length < state.search.limit}
              // onClick={() => {
              //   onNextOrPrevFunc(true);
              // }}
            />
            <Icon
              path={mdiChevronRight}
              size={0.9}
              className="btnIcon"
              style={{ marginBottom: -6, marginLeft: -8, color: "#135c8a" }}
            />
          </span>
        </Stack.Item> */}
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deletePmsFile(
                    state.manageActionsCallout
                      .data as IPreventiveMaintenenceSchedule,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.managePmsDialog.isOpen && (
        <ManagePMScheduleDialog
          handleLoading={handleLoading}
          handleDialogClose={(data: IPreventiveMaintenenceSchedule) =>
            handleDialogClose(data)
          }
          customer={customer.customer}
          datacenterList={state.dataCenterList}
          pmsFiles={state.pmsFiles}
          data={state.managePmsDialog.data}
          date={state.search.date}
        />
      )}
    </React.Fragment>
  );
};

export default PMSchedule;
